module.exports = new __parcel__URL__("shadowspike.b57e4804.png").toString();